import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-error-page',
  templateUrl: './errorPage.component.html'
})
export class ErrorPageComponent implements OnInit {
  error: {

  };
  errorReturned: { };
  constructor(
    private _router: Router,
  ) {

  }
  ngOnInit() {
   /*  console.log(this.errorReturned);
    let error = {}
    error['name'] = this.errorReturned['name'];
    error['message'] = this.errorReturned['error']['error']['message'];
    error['exception'] = this.errorReturned['error']['error']['exception'];
    error['status'] = this.errorReturned['status'];
    error['text'] = this.errorReturned['statusText'];
    this.error = error;
 */
  }

}
